import React, { useEffect, useRef } from 'react';
import './UseCases.css';

import itLogo from './logos/IT_logo.png';
import manufactureLogo from './logos/manufacture_logo.png';
import bankLogo from './logos/bank_logo.png';
import healthcareLogo from './logos/healthcare.png';
import moreLogo from './logos/and_many_more.png';

const CASES = [
  { logo: itLogo, title: 'Information Technology', desc: 'Coding concepts, system design, and software architecture questions tailored per stack and experience level.' },
  { logo: manufactureLogo, title: 'Manufacturing', desc: 'Operations, quality control, and safety protocol knowledge for production and logistics roles.' },
  { logo: bankLogo, title: 'Banking, Financial Services, and Insurance.', desc: 'Risk assessment, regulatory knowledge, and financial modeling evaluation for banking roles.' },
  // { logo: healthcareLogo,  title: 'Healthcare',             desc: 'Clinical knowledge, patient care scenarios, and compliance based evaluation for medical roles.' },
  { logo: moreLogo, title: 'and many more..', desc: 'Supporting a wide range of industries with tailored assessments that measure practical skills and job ready knowledge.' },
];

export default function UseCases() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e, i) => {
        if (e.isIntersecting) setTimeout(() => e.target.classList.add('visible'), i * 90);
      }),
      { threshold: 0.1 }
    );
    if (ref.current) ref.current.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="usecases" className="section-wrap uc-section" ref={ref}>
      <div className="uc-header reveal">
  <div className="section-label">Use Cases</div>
  <h2 className="section-title">Built for every industry</h2>
  <p className="section-sub">
   MeruBot adapts to any domain — generating precise, context-aware questions for any role in your organization.
  </p>
</div>
      <div className="uc-grid">
        {CASES.map(c => (
          <div key={c.title} className="uc-card reveal">
            <div className="uc-icon">
              <img src={c.logo} alt={c.title} />
            </div>
            <h4>{c.title}</h4>
            <p>{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}